import { CompanyPublicationPagination } from '@models/company/company-publication-pagination';

export class GetNews {
  static readonly type = '[News] Get';
  constructor(public profileId: string) {}
}

export class GetNewsSuccess {
  static readonly type = '[News] Get Success';
  constructor(public companyPublications: CompanyPublicationPagination) {}
}

export class GetNewsFailed {
  static readonly type = '[News] Get Failed';
  constructor(public error: any) {}
}

export class LoadMore {
  static readonly type = '[News] Load More';
  constructor(public profileId: string) {}
}

export class LoadMoreSuccess {
  static readonly type = '[News] Load More Success';
  constructor(public companyPublications: CompanyPublicationPagination) {}
}

export class LoadMoreFailed {
  static readonly type = '[News] Load More Failed';
  constructor(public error: any) {}
}
